import { render } from "./DriftBottlesList.vue?vue&type=template&id=70768636"
import script from "./DriftBottlesList.vue?vue&type=script&lang=js"
export * from "./DriftBottlesList.vue?vue&type=script&lang=js"

import "./DriftBottlesList.vue?vue&type=style&index=0&id=70768636&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__